export const statusOptions = [
  { id: 'All', description: 'Todos' },
  { id: 1, description: 'AGUARDANDO CONTATO' },
  { id: 2, description: 'AGUARDANDO RETORNO' },
  { id: 3, description: 'REPROVADO' },
  { id: 4, description: 'APROVADO' },
  { id: 5, description: 'CANCELADO' },
  { id: 6, description: 'SEM CONTATO' },
  { id: 7, description: 'CONTATO SEM SUCESSO' },
  { id: 8, description: 'AGUARDANDO PAGAMENTO' },
  { id: 9, description: 'Pagamento Realizado' },
  { id: 10, description: 'Não Pago' },
  { id: 11, description: 'Orçamento Criado' },
  { id: 12, description: 'Execução do Reparo' },
  { id: 13, description: 'Devolução do aparelho' },
  { id: 14, description: 'CANCELADO' },
  { id: 15, description: 'PAGAMENTO DE METADE' },
  { id: 16, description: 'Aguardando Peças' },
  { id: 17, description: 'CONCLUIDO' },
  { id: 18, description: 'EXECUÇÃO DO REPARO' },
  { id: 19, description: 'Aguardando aprov. SAW por Laudo técnico' },
  { id: 20, description: 'SEM RETORNO DO CLIENTE' },
  { id: 21, description: '1º TENTATIVA REALIZADA' },
  { id: 22, description: '2º TENTATIVA REALIZADA' },
  { id: 23, description: '3º TENTATIVA REALIZADA' },
  { id: 24, description: 'ABERTURA DE GTI' },
  { id: 25, description: '1º TENTATIVA WHATSAPP' },
  { id: 32, description: 'GTI - Desbloqueio Google' },
  { id: 33, description: '1ª TENTATIVA WHATSAPP2' },
  { id: 34, description: '1ª TENTATIVA POR E-MAIL' },
  { id: 35, description: 'AGUARDANDO GERAÇÃO BOLETO AUTOMATICO' },
  { id: 36, description: 'AGUARDANDO PAGAMENTO (BOLETO)' },
  { id: 37, description: 'PAGAMENTO IDENTIFICADO(BOLETO)' },
  { id: 38, description: '(PAGO) VALOR DIVERGENTE' },
  { id: 39, description: 'Conector Danificado' },
  { id: 40, description: 'GTI – Mancha no  display' },
  { id: 47, description: '1º TENTATIVA WHATSAPP3' },
  { id: 48, description: 'Acordo Samsung' },
  { id: 49, description: 'ACORDO SIS' },
  { id: 50, description: 'ACORDO SIS' },
  { id: 51, description: '1º TENTATIVA WHATSAPP4' },
  { id: 52, description: 'ACORDO PLL' },
  { id: 53, description: 'Reprovado - Bateria' },
  { id: 54, description: 'Reprovado-Tela trincada' },
  { id: 55, description: '1º TENTATIVA WHATSAPP5' },
  { id: 56, description: 'Reprovado  Dano Processo' },
  { id: 57, description: 'Reprovado - Seguro' },
  { id: 58, description: 'Reprovado - Venda de Acessório' },
  { id: 59, description: 'Reprovado - conector USB' },
  { id: 60, description: 'Pagamento Realizado SC+' },
  { id: 61, description: 'TRADE IN APROVADO' },
  { id: 62, description: 'Pagamento Realizado SWAP' },
];
